
export const dataHistoric = [
    {
        date: "Mar 2012",
        rate: 1.6,
    },
    {
        date: "Jun 2012",
        rate: 1.2,
    },
    {
        date: "Sep 2012",
        rate: 2.0,
    },
    {
        date: "Dec 2012",
        rate: 2.2,
    },
    {
        date: "Mar 2013",
        rate: 2.5,
    },
    {
        date: "Jun 2013",
        rate: 2.4,
    },
    {
        date: "Sep 2013",
        rate: 2.2,
    },
    {
        date: "Dec 2013",
        rate: 2.7,
    },
    {
        date: "Mar 2014",
        rate: 2.9,
    },
    {
        date: "Jun 2014",
        rate: 3.0,
    },
    {
        date: "Sep 2014",
        rate: 2.3,
    },
    {
        date: "Dec 2014",
        rate: 1.7,
    },
    {
        date: "Mar 2015",
        rate: 1.3,
    },
    {
        date: "Jun 2015",
        rate: 1.5,
    },
    {
        date: "Sep 2015",
        rate: 1.5,
    },
    {
        date: "Dec 2015",
        rate: 1.7,
    },
    {
        date: "Mar 2016",
        rate: 1.3,
    },
    {
        date: "Jun 2016",
        rate: 1.0,
    },
    {
        date: "Sep 2016",
        rate: 1.3,
    },
    {
        date: "Dec 2016",
        rate: 1.5,
    },
    {
        date: "Mar 2017",
        rate: 2.1,
    },
    {
        date: "Jun 2017",
        rate: 1.9,
    },
    {
        date: "Sep 2017",
        rate: 1.8,
    },
    {
        date: "Dec 2017",
        rate: 1.9,
    },
    {
        date: "Mar 2018",
        rate: 1.9,
    },
    {
        date: "Jun 2018",
        rate: 2.1,
    },
    {
        date: "Sep 2018",
        rate: 1.9,
    },
    {
        date: "Dec 2018",
        rate: 1.8,
    },
    {
        date: "Mar 2019",
        rate: 1.3,
    },
    {
        date: "Jun 2019",
        rate: 1.6,
    },
    {
        date: "Sep 2019",
        rate: 1.7,
    },
    {
        date: "Dec 2019",
        rate: 1.8,
    },
    {
        date: "Mar 2020",
        rate: 2.2,
    },
    {
        date: "Jun 2020",
        rate: -0.3,
    },
    {
        date: "Sep 2020",
        rate: 0.7,
    },
    {
        date: "Dec 2020",
        rate: 0.9,
    },
    {
        date: "Mar 2021",
        rate: 1.1,
    },
    {
        date: "Jun 2021",
        rate: 3.8,
    },
    {
        date: "Sep 2021",
        rate: 3.0,
    },
    {
        date: "Dec 2021",
        rate: 3.5,
    },
    {
        date: "Mar 2022",
        rate: 5.1,
    },
    {
        date: "Jun 2022",
        rate: 6.1,
    },
    {
        date: "Sep 2022",
        rate: 7.3,
    },
    {
        date: "Dec 2022",
        rate: 7.8,
    },
    {
        date: "Mar 2023",
        rate: 7.0,
    },
    {
        date: "Jun 2023",
        rate: 6.0,
    },
    {
        date: "Sep 2023",
        rate: 5.4,
    },
    {
        date: "Oct 2023",
        rate: 4.9,
    },
    {
        date: "Dec 2023",
        rate: 4.1,
    },
    {
        date: "Mar 2024",
        rate: 3.6,
    },
    {
        date: "Jun 2024",
        rate: 3.8,
    },
    {
        date: "Sep 2024",
        rate: 3.5,
    },
    {
        date: "Dec 2024",
        rate: 2.4,
    },
        {
        date: "Mar 2025",
        rate: 2.4,
    },

]

//https://www.rba.gov.au/publications/smp/2023/may/economic-outlook.html
//https://www.rba.gov.au/publications/smp/2023/nov/economic-outlook.html
// https://www.rba.gov.au/publications/smp/2024/nov/
export const dataProjection = [


    {
        date: "Jun 2025",
        rate: 2.1,
    },
    // {
    //     date: "Sep 2025",
    //     rate: 2.5,
    // },
    {
        date: "Dec 2025",
        rate: 3.0,
    },
    // {
    //     date: "Mar 2026",
    //     rate: 3.3,
    // },
    {
        date: "Jun 2026",
        rate: 3.1,
    },
    // {
    //     date: "Sep 2026",
    //     rate: 2.8,
    // },
    {
        date: "Dec 2026",
        rate: 2.9,
    },
    // {
    //     date: "Mar 2027",
    //     rate: 2.7,
    // },
    {
        date: "Jun 2027",
        rate: 2.6,
    },

]





// Wage price index
// https://www.abs.gov.au/statistics/economy/price-indexes-and-inflation/wage-price-index-australia/latest-release
export const WPI = [

    {
        date: "Mar 2012",
        private: 3.8,
        adjusted: 3.6,
    },
    {
        date: "Jun 2012",
        private: 3.9,
        adjusted: 3.8,
    },
    {
        date: "Sep 2012",
        private: 3.8,
        adjusted: 3.8,
    },
    {
        date: "Dec 2012",
        private: 3.4,
        adjusted: 3.4,
    },



    {
        date: "Mar 2013",
        private: 3.2,
        adjusted: 3.1,
    },
    {
        date: "Jun 2013",
        private: 3.0,
        adjusted: 2.8,
    },
    {
        date: "Sep 2013",
        private: 2.7,
        adjusted: 2.6,
    },
    {
        date: "Dec 2013",
        private: 2.5,
        adjusted: 2.6,
    },



    {
        date: "Mar 2014",
        private: 2.6,
        adjusted: 2.7,
    },
    {
        date: "Jun 2014",
        private: 2.4,
        adjusted: 2.6,
    },
    {
        date: "Sep 2014",
        private: 2.1,
        adjusted: 2.6,
    },
    {
        date: "Dec 2014",
        private: 2.5,
        adjusted: 2.5,
    },



    {
        date: "Mar 2015",
        private: 2.2,
        adjusted: 2.3,
    },
    {
        date: "Jun 2015",
        private: 2.2,
        adjusted: 2.3,
    },
    {
        date: "Sep 2015",
        private: 2.1,
        adjusted: 2.3,
    },
    {
        date: "Dec 2015",
        private: 2.0,
        adjusted: 2.2,
    },


    {
        date: "Mar 2016",
        private: 1.9,
        adjusted: 2.1,
    },
    {
        date: "Jun 2016",
        private: 2.0,
        adjusted: 2.1,
    },
    {
        date: "Sep 2016",
        private: 1.9,
        adjusted: 1.9,
    },
    {
        date: "Dec 2016",
        private: 1.8,
        adjusted: 1.9,
    },


    {
        date: "Mar 2017",
        private: 1.8,
        adjusted: 1.9,
    },
    {
        date: "Jun 2017",
        private: 1.8,
        adjusted: 1.9,
    },
    {
        date: "Sep 2017",
        private: 1.9,
        adjusted: 2.0,
    },
    {
        date: "Dec 2017",
        private: 1.9,
        adjusted: 2.1,
    },
    {
        date: "Mar 2018",
        private: 1.9,
        adjusted: 2.0,
    },
    {
        date: "Jun 2018",
        private: 2.1,
        adjusted: 2.1,
    },
    {
        date: "Sep 2018",
        private: 2.1,
        adjusted: 2.3,
    },
    {
        date: "Dec 2018",
        private: 2.3,
        adjusted: 2.3,
    },
    {
        date: "Mar 2019",
        private: 2.4,
        adjusted: 2.3,
    },
    {
        date: "Jun 2019",
        private: 2.3,
        adjusted: 2.3,
    },
    {
        date: "Sep 2019",
        private: 2.2,
        adjusted: 2.2,
    },
    {
        date: "Dec 2019",
        private: 2.2,
        adjusted: 2.2,
    },
    {
        date: "Mar 2020",
        private: 2.1,
        adjusted: 2.2
    },
    {
        date: "Jun 2020",
        private: 1.7,
        adjusted: 1.8,
    },
    {
        date: "Sep 2020",
        private: 1.2,
        adjusted: 1.4,
    },
    {
        date: "Dec 2020",
        private: 1.4,
        adjusted: 1.3,
    },
    {
        date: "Mar 2021",
        private: 1.4,
        adjusted: 1.5,
    },
    {
        date: "Jun 2021",
        private: 1.9,
        adjusted: 1.8,
    },
    {
        date: "Sep 2021",
        private: 2.4,
        adjusted: 2.2,
    },
    {
        date: "Dec 2021",
        private: 2.4,
        adjusted: 2.4,
    },
    {
        date: "Mar 2022",
        private: 2.4,
        adjusted: 2.4,
    },
    {
        date: "Jun 2022",
        private: 2.7,
        adjusted: 2.7,
    },
    {
        date: "Sep 2022",
        private: 3.2,
        adjusted: 3.2,
    },
    {
        date: "Dec 2022",
        private: 3.3,
        adjusted: 3.3,
    },
    {
        date: "Mar 2023",
        private: 3.8,
        adjusted: 3.7,
    },
    {
        date: "Jun 2023",
        private: 3.8,
        adjusted: 3.6,
    },
    {
        date: "Sep 2023",
        private: 4.2,
        adjusted: 4.0,
    },
    {
        date: "Dec 2023",
        private: 4.2,
        adjusted: 4.2,
    },
    {
        date: "Mar 2024",
        private: 4.1,
        adjusted: 4.0,
    },
    {
        date: "Jun 2024",
        private: 4.1,
        adjusted: 4.1,
    },
    {
        date: "Sep 2024",
        private: 3.5,
        adjusted: 3.6,
    },
    {
        date: "Dec 2024",
        private: 3.25,
        adjusted: 3.2,
    },
        {
        date: "Mar 2025",
        private: 3.5,
        adjusted: 3.4,
    },

]



